"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.OPEventRecordDeleted = void 0;
const const_1 = require("../../../event_manager/const");
const helper_1 = require("../../../event_manager/helper");
const resource_types_1 = require("../../../types/resource_types");
const interface_1 = require("../interface");
class OPEventRecordDeleted extends interface_1.IAtomEventType {
    constructor() {
        super(...arguments);
        this.eventName = const_1.OPEventNameEnums.RecordDeleted;
        this.realType = const_1.EventRealTypeEnums.REAL;
        this.scope = resource_types_1.ResourceType.Datasheet;
    }
    test(args) {
        const { action, resourceId } = args;
        const { pass, recordId } = (0, helper_1.testPath)(action.p, ['recordMap', ':recordId'], action.n === 'OD');
        return {
            pass,
            context: {
                datasheetId: resourceId,
                recordId,
            }
        };
    }
}
exports.OPEventRecordDeleted = OPEventRecordDeleted;
//# sourceMappingURL=record_deleted.js.map